import React from "react";

// A drawn + in currentColor for the round add control and the cart's quantity control: a text "+"
// sits on the font's baseline and looks low, this is centred exactly
const PlusIcon = ({ size = 18 }: any) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" aria-hidden="true">
    <path d="M9 2v14M2 9h14" />
  </svg>
);

export default PlusIcon;
